const EASTERN_TIME_ZONE = "America/New_York";

// Maps an instant to its calendar year and month in America/New_York, independent of the
// browser's own local time zone. Backed by the IANA time zone database (via Intl), so US
// Eastern's EST/EDT daylight-saving transitions are handled automatically - no fixed UTC
// offset is assumed.
const easternYearMonth = (date: Date) => {
  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone: EASTERN_TIME_ZONE,
    year: "numeric",
    month: "numeric",
  }).formatToParts(date);
  return {
    year: Number(parts.find(part => part.type === "year")?.value),
    month: Number(parts.find(part => part.type === "month")?.value),
  };
};

// A quote's pricing is current through 11:59:59 PM Eastern Time on the last day of the
// Eastern calendar month it was priced in, and goes stale the instant that month rolls
// over - regardless of the UTC date or the viewer's own local time zone. Comparing UTC
// calendar fields instead (the bug this replaces) can mark a quote expired hours early:
// 8:00 PM EDT on August 31 is already September 1 in UTC.
// An unparseable or missing timestamp is always treated as stale.
export const isPricingStale = (lastPricedAt: string, now = new Date()) => {
  const priced = new Date(lastPricedAt);
  if (Number.isNaN(priced.getTime())) return true;
  const pricedMonth = easternYearMonth(priced);
  const currentMonth = easternYearMonth(now);
  return pricedMonth.year !== currentMonth.year || pricedMonth.month !== currentMonth.month;
};
